// @ts-nocheck

import { colors } from '@lmc/common/constants'
import PropTypes from 'prop-types'
import React from 'react'
import { AntdPopconfirm } from '../AntdPopconfirm'
import HelpLink from '../HelpLink/HelpLink'

export default function FormFieldLayout({
  askConfirm, // if true, will ask for confirmation
  children,
  confirmClassName, // sets styles for confirm
  confirmProps, // passes in icons etc
  displayLabel = true,
  hasErrors,
  layout = 'row',
  isNestedField,
  label,
  labelChildren, // Can pass components to be part of label.
  labelHelpLink,
  labelNote,
  labelStyle,
  note,
  onConfirm, // Function that fires on confirm
  style,
  supportLink,
  required,
  floatHelpLink,
  centerLabel
}) {
  return (
    <div
      style={{
        ...styles.wrapper,
        flexFlow: layout === 'row' ? 'row wrap' : 'column',
        marginTop: !displayLabel ? 12 : 0
      }}
    >
      {layout !== 'no-label' && (
        <div
          style={{
            ...styles.labelWrapper,
            paddingBottom: displayLabel && label ? 5 : 0
          }}
        >
          <div
            className="lmc-form-field-label"
            style={{
              ...styles.label,
              color: hasErrors ? colors.red : null,
              fontWeight: isNestedField ? 500 : 600,
              marginTop: centerLabel ? 10 : 0,
              ...labelStyle
            }}
          >
            {displayLabel && label}
            {displayLabel && required && (
              <span style={{ color: colors.red }}>{` *`} </span>
            )}
            {labelHelpLink && (
              <span>
                {` `} <HelpLink supportLink={labelHelpLink} />
              </span>
            )}
            {labelNote && (
              <span style={styles.labelNote}>{` ${labelNote}`}</span>
            )}
            {labelChildren}
          </div>
        </div>
      )}
      <div style={{ ...styles.componentWrapper, ...style }}>
        {askConfirm ? (
          <div className={confirmClassName}>
            <AntdPopconfirm confirmProps={confirmProps} onConfirm={onConfirm}>
              {children}
            </AntdPopconfirm>
          </div>
        ) : (
          children
        )}
        {floatHelpLink && <br />}
        {(note || supportLink) && (
          <div
            style={{ ...styles.note, ...(floatHelpLink && styles.floatNote) }}
          >
            {note && <text style={styles.noteText}>{`${note} `}</text>}
            {supportLink && <HelpLink supportLink={supportLink} />}
          </div>
        )}
      </div>
    </div>
  )
}

const styles = {
  componentWrapper: {
    flex: 3,
    minWidth: 180
  },
  label: {
    marginRight: 5
  },
  labelNote: {
    color: colors.darkgrey,
    fontWeight: 'normal',
    fontSize: 12
    // fontStyle: 'italic'
  },
  labelWrapper: {
    display: 'flex',
    flex: 1,
    flexFlow: 'row wrap',
    marginRight: 30,
    minWidth: 160
  },
  note: {
    color: colors.darkgrey,
    fontSize: 12,
    paddingTop: 5
  },
  floatNote: {
    position: 'absolute',
    bottom: 25,
    transform: 'scale(1.2)'
  },
  noteText: {
    whiteSpace: 'pre-wrap'
  },
  wrapper: {
    display: 'flex',
    minHeight: 34,
    width: '100%'
  }
}

FormFieldLayout.propTypes = {
  askConfirm: PropTypes.bool,
  children: PropTypes.node.isRequired,
  confirmClassName: PropTypes.string,
  confirmProps: PropTypes.object,
  displayLabel: PropTypes.bool,
  hasErrors: PropTypes.bool,
  isNestedField: PropTypes.bool,
  label: PropTypes.string,
  labelChildren: PropTypes.node,
  layout: PropTypes.oneOf(['row', 'column', 'no-label']),
  note: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onConfirm: PropTypes.func,
  required: PropTypes.bool
}
